import styled, { css } from "styled-components";
import { theme } from "styles/mui-config";
import Paper from "@mui/material/Paper";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";
import MenuIcon from "@mui/icons-material/Menu";
import ListItemIcon from "@mui/material/ListItemIcon";
import ImageHeader from "assets/img/Header.png";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import ListItemText from "@mui/material/ListItemText";
import ListItem from "@mui/material/ListItem";
import KeyboardArrowLeftIcon from "@mui/icons-material/KeyboardArrowLeft";
import MenuItem from "@mui/material/MenuItem";
import Drawer from "@mui/material/Drawer";

export const StyledDrawer = styled(Drawer)`
  & > div {
    height: calc(100% - 0px) !important;
  }
`;

export const StyledMenuItem = styled(MenuItem)`
  padding: 0 !important;
  direction: rtl;
  & > a {
    padding-top: 6px;
    padding-bottom: 6px;
    padding-right: 10px;
    padding-left: 16px;
    text-align: right;
    font-size: 14px;
    width: 100%;
    height: 100%;
    color: ${theme.palette.primary.main} !important;
    display: flex;
    align-items: center;
  }
  & > a > svg {
    margin-left: 9px;
    font-size: 22px;
  }
`;

export const StyledListItemIcon = styled(ListItemIcon)`
  & svg {
    color: ${theme.palette.primary.main};
  }
`;

export const StyledIconTitleDiv = styled.div`
  display: flex;
  justify-content: end;
  align-items: center;

  & svg {
    width: 16px;
    height: 16px;
    color: #a4a6ac !important;
  }
`;

export const StyledLinkMobileIcon = styled.div`
  @media (min-width: 1000px) {
    display: none !important;
  }
`;

export const StyledItemIcon = styled(KeyboardArrowLeftIcon)`
  color: #a4a6ac !important;
  text-align: right;
`;

export const StyledListAllItemIcon = styled(ListItemIcon)`
  & svg {
    color: #a4a6ac !important;
    margin-right: -75px;
    margin-top: 3px;
    font-size: 22px;
  }
`;

export const StyledListItem = styled(ListItem)`
  // & a > div > svg {
  //   color: #009ac299 !important;
  // }
`;

export const StyledListItemText = styled(ListItemText)`
  & span {
    font-size: 15px;
    color: #222;
  }
`;

export const StyledListAllItemText = styled(ListItemText)`
  & span {
    font-size: 13px;
    color: #a4a6ac;
    line-height: 2.17;
  }
`;

export const StyledAccordion = styled(Accordion)`
  background-color: transparent !important;
  box-shadow: none !important;
  direction: rtl;
  width: 100%;

  :hover {
    background-color: rgba(0, 0, 0, 0) !important;
  }
`;
export const StyledAccordionSummary = styled(AccordionSummary)`
  padding: 0 !important;
  padding-right: 16px !important;
  padding-left: 16px !important;
  margin: 0 !important;
  .muirtl-o4b71y-MuiAccordionSummary-content {
    margin: 0 !important;
  }
`;
export const StyledAccordionDetails = styled(AccordionDetails)`
  padding: 0 !important;
  margin: 0 !important;
`;

export const StyledPaper = styled(Paper)`
  height: 350px !important;
  padding: 20px;
  border-radius: 0px !important;
  margin-bottom: 50px;
  display: flex;
  justify-content: space-around;
  color: white !important;
  background-color: transparent !important;
  background-image: url(${ImageHeader});
  background-size: 100% 100% !important;
  background-repeat: no-repeat !important;
  @media (max-width: 981px) {
    background-size: 2000px !important;
    background-position: 50% 110% !important;
  }
  // @media (max-width: 1000px) {
  //   justify-content: space-between;
  // }

  & ul {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 13px;
    @media (max-width: 1000px) {
      display: none;
    }
  }
  & ul > li {
    float: right;
    padding: 13px;
    cursor: pointer;
  }
  & h1 {
    position: absolute !important;
    top: 120px;
    text-align: center;
    font-weight: bold !important;
    font-family: "Avini";
    font-size: 50px;
  }
  & h4 {
    position: absolute !important;
    top: 200px;
    font-weight: bold !important;
    font-family: "Avini";
    font-size: 25px;
  }
`;

export const StyledPaperDetail = styled(Paper)`
  padding: 20px;
  border-radius: 0px !important;
  display: flex;
  justify-content: space-around;
  color: white !important;
  background-color: #149ec4 !important;
  @media (max-width: 981px) {
    background-size: 2000px !important;
    background-position: 50% 110% !important;
  }

  & ul {
    list-style: none;
    margin: 0;
    padding: 0;
    margin-top: 13px;
    @media (max-width: 1000px) {
      display: none;
    }
  }
  & ul > li {
    float: right;
    padding: 13px;
    cursor: pointer;
  }
  & h1 {
    position: absolute !important;
    top: 120px;
    text-align: center;
    font-weight: bold !important;
    font-family: "Avini";
    font-size: 50px;
  }
  & h4 {
    position: absolute !important;
    top: 200px;
    font-weight: bold !important;
    font-family: "Avini";
    font-size: 25px;
  }
`;

export const StyledPaperIndex = styled(Paper)`
  // height: 100px !important;
  width: 100% !important;
  display: flex;
  flex-direction: column;
  // justify-content: space-around;
  // align-items: center;
  background: white !important;
  // border: 1px solid red;
  border-radius: 0px !important;
  padding: 20px;
  padding-top: 9px;
  padding-bottom: 0px;
  // position: fixed;
  z-index: 20;
  box-shadow: 0 1px 0 rgba(0, 0, 0, 0.13), 0 2px 0 rgba(0, 0, 0, 0.05) !important;
  position: relative;

  @media (max-width: 1000px) {
    justify-content: space-between;
    // align-items: center;
    padding-bottom: 20px !important;
  }

  @media (max-width: 899.9px) {
    // justify-content: center;
  }

  & ul {
    list-style: none;
    margin: 0;
    padding: 0;
    @media (max-width: 1000px) {
      display: none;
    }
  }
  & ul > li {
    float: right;
    padding: 13px;
    cursor: pointer;
  }
`;

export const StyledMobileLogoDetail = styled.img`
  height: 50px !important;
  width: 156px !important;
  margin-left: 15px;
  cursor: pointer;
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const StyledMobileLogo = styled.img`
  height: 37px !important;
  width: 130px !important;
  margin-left: 15px;
  cursor: pointer;
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const StyledMobileImage = styled.img`
  display: none !important;
  cursor: pointer;
  @media (max-width: 1000px) {
    height: 46px !important;
    width: 64px !important;
    display: inline-block !important;
  }
`;

export const StyledMobileImage2 = styled.img`
  display: none !important;
  cursor: pointer;
  @media (max-width: 1000px) {
    height: 50px !important;
    width: 160px !important;
    display: inline-block !important;
    margin-top: -10px;
  }
`;

export const StyledLink = styled(Link)`
  color: white;
  display: flex;
  direction: rtl;
  position: relative;
  &::after {
    width: 100%;
    height: 2px;
    background: linear-gradient(90deg, #04c1f3, white);
    border-radius: 100px;
    position: absolute;
    right: 0px;
    bottom: -5px;
    content: "";
    transform: scale(0, 1);
    transition: all 0.3s ease 0s;
    transform-origin: center 0px;
  }
  &:hover {
    &::after {
      transform-origin: center 0px;
      transform: scale(1);
    }
  }
`;

export const StyledLinkSpan = styled.span`
  color: white;
  display: flex;
  direction: rtl;
`;

export const StyledLinkMobile = styled(Link)`
  color: #000000;
  display: flex;
  direction: rtl;
`;

export const StyledMenuIcon = styled(MenuIcon)`
  display: none !important;
  color: ${theme.palette.primary.contrastText};
  font-size: 40px !important;
  cursor: pointer;
  @media (max-width: 1000px) {
    display: inline-block !important;
  }
`;

export const StyledIndexUl = styled.div`
  & ul > li > a {
    color: black;
    &::after {
      width: 100%;
      height: 2px;
      background: linear-gradient(90deg, #04c1f3, black);
      border-radius: 100px;
      position: absolute;
      right: 0px;
      bottom: -5px;
      content: "";
      transform: scale(0, 1);
      transition: all 0.3s ease 0s;
      transform-origin: center 0px;
    }
    &:hover {
      &::after {
        transform-origin: center 0px;
        transform: scale(1);
      }
    }
  }
`;

export const StyledButtonIndex = styled(Button)`
  color: #004a5e !important;
  border: 1px solid #dfdfe6 !important;
  // margin-top: 8px !important;
  @media (max-width: 1000px) {
    margin-top: 0px !important;
    border: 1px solid transparent !important;
  }
`;
export const StyledButtonIndexSearch = styled(Button)`
  color: #004a5e !important;
  // border: 1px solid #f1f2f4 !important;
  background: #f1f2f4 !important;
  height: 44px;
  width: 600px;
  margin-left: 20px;
  margin-right: 20px;
  border-radius: 8px !important;
  display: flex !important;
  justify-content: end !important;
  cursor: text !important;
  & > span {
    padding-right: 16px;
    color: #787991;
    font-size: 13px;
  }
  @media (max-width: 1150px) {
    width: 400px;
  }
  @media (max-width: 1000px) {
    margin-top: 0px !important;
    border: 1px solid transparent !important;
    background: transparent !important;
    width: auto;
    justify-content: center !important;
    cursor: pointer !important;
    & > span {
      display: none;
    }
  }
`;

export const StyledButton = styled(Button)`
  color: ${theme.palette.primary.contrastText} !important;
  border: 1px solid ${theme.palette.primary.contrastText} !important;
  margin-top: 8px !important;
  font-size: 14px;
  @media (max-width: 1000px) {
    margin-top: 0px !important;
    border: 1px solid transparent !important;
  }
`;

export const StyledLinkLogin = styled(Link)`
  @media (max-width: 1000px) {
    display: none !important;
  }
`;

export const StyledLinkcart = styled(Link)`
  width: 56px;
  height: 56px;
  z-index: 1050;
  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.2),
    0px 6px 10px 0px rgba(0, 0, 0, 0.14), 0px 1px 18px 0px rgba(0, 0, 0, 0.12);
  color: #fff;
  background-color: #fff;
  border-radius: 50%;
  position: fixed;
  bottom: 20px;
  left: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: 225ms cubic-bezier(0.4, 0, 0.2, 1) 0ms;
  & > span > span {
    top: -5px;
    right: -5px;
    background: white;
    border: 1.5px solid white;
    background: ${theme.palette.primary.dark};
    color: white;
  }
  & > span > svg {
    color: ${theme.palette.primary.dark};
  }
  :hover {
    background-color: #fff;
  }
  :active {
    box-shadow: 0px 7px 8px -4px rgba(0, 0, 0, 0.2),
      0px 12px 17px 2px rgba(0, 0, 0, 0.14),
      0px 5px 22px 4px rgba(0, 0, 0, 0.12);
  }
  @media (max-width: 1000px) {
    display: none;
  }
`;

export const StyledCircle = styled.div`
  width: 600px;
  height: 600px;
  border-radius: 100px;
  background: ${theme.palette.primary.main};
  position: fixed;
  left: -230px;
  top: -230px;
  z-index: -1;
  transform: rotate(45deg);
`;

export const StyledLogo = styled.div`
  padding: 30px;
  padding-bottom: 60px;
  position: relative;
  & img {
    width: 100%;
  }
`;

export const StyledMobLinkLogin = styled(Link)`
  color: white;
  display: flex;
  direction: rtl;
  background: ${theme.palette.primary.main};
  border-top-left-radius: 15px;
  border-bottom-left-radius: 15px;
  position: absolute;
  right: 0;
  bottom: 11px;
  padding: 5px;
  width: 140px !important;
  justify-content: center;
  align-items: center;
  box-shadow: 0px 0px 0px 0px rgba(0, 0, 0, 0.2),
    0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  transition: 0.3s;
  & div {
    text-align: center;
  }
  & div > span {
    font-size: 12px;
  }
  :hover {
    background: ${theme.palette.primary.dark};
  }
  :active {
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.2),
      0px 1px 1px 0px rgba(0, 0, 0, 0.14), 0px 1px 3px 0px rgba(0, 0, 0, 0.12);
  }
`;

export const StyledTopMenu = styled.div`
  display: flex;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledSearchContainer = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 52px;
`;
